interface SignUpVolunteerPayload {
  firstName: string
  lastName: string
  email: string
  phoneNumber?: string
  password: string
  passwordConfirmation: string
}

export async function signUpVolunteer(attributes: SignUpVolunteerPayload) {
  const { data: user } = await $api<JSONAPIResponse<User>>(
    '/api/v1/volunteers',
    {
      method: 'POST',
      body: {
        data: {
          type: 'user',
          attributes: attributes,
        },
      },
    },
  )

  return user
}
